import React, { useState, useEffect } from "react";

import * as api from '../api/index'

import {
  Typography,
  Button,
  IconButton,
  ButtonGroup,
  Modal,
  TextField,
  Divider,
  Chip,
} from "@material-ui/core";
import { useDiscount } from "../Context/DiscountContext";
import { useCart } from "../Context/CartContext";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import { makeStyles } from "@material-ui/core/styles";
import useStyles from "./CartStyles";
import { useEffectiveProfile } from "../utils/useEffectiveProfile";
import { getTaxLabel, formatFinalAmount } from "../utils/currency";

const CartSummary = ({ currency }) => {
    const classes=useStyles();
    const effectiveProfile = useEffectiveProfile();
    const taxLabel = getTaxLabel(effectiveProfile?.currency);
    const {
        discountType,
        setDiscountType,
        discountVal,
        setDiscountVal,
        discountFlag,
        setDiscountFlag,
        openDiscountbox,
        setOpenDiscountbox,
        handleDiscountTypeChange,
        handleDisountBoxOpen,
        handleDisountBoxClose,
        handleAddDiscount,
        calculateDiscount,
        clearDiscount,
      } = useDiscount();
      const {
        cartItems,
        selectedIndex,
        addToCart,
        removeFromCart,
        incrementQuantity,
        decrementQuantity,
        getTotalPrice,
        getRoundOff,
        getSubTotalPrice,
        calculatePrice,
        handleOpenQtyDialog,
        handleCloseQtyDialog,
        QtydialogOpen,
        handleQuantityChange,
        calculateVat,
        subTotal,
        setSubTotal,
        setCartItems,
        vat,
        setVat,
        getOriginalSubTotalPrice,
      } = useCart();

      const isError =
      (discountType && discountVal > 100) || discountVal >= getSubTotalPrice();

// State for permissions and loading
const [canApplyDiscount, setCanApplyDiscount] = useState(false);
const [isAdmin, setIsAdmin] = useState(false);
const [loading, setLoading] = useState(true);

// Fetch permissions from database
useEffect(() => {
  const fetchPermissions = async () => {
    try {
      const profile = JSON.parse(localStorage.getItem("profile")) || {};
      if (!profile.token) throw new Error("No token found");
      setIsAdmin(profile?.result?.userType?.includes("admin") || false);

      const { data } = await api.getUserPermissions();
      setCanApplyDiscount(data.canApplyCustomDiscount || false);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching permissions:", error.message);
      setCanApplyDiscount(false); // Fallback to no permission
      setLoading(false);
    }
  };
  fetchPermissions();
}, []);

  return (
    <div className={classes.totalAmountSection}>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Original Sub-Total:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getOriginalSubTotalPrice().toFixed(2)}`}
        </span>
      </Typography>
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Adjusted Sub-Total:{" "}
        <span className={classes.amountValue}>
          {`${currency}${getSubTotalPrice().toFixed(2)}`}
        </span>
      </Typography>
      {Math.abs(getSubTotalPrice() - getOriginalSubTotalPrice()) > 0.009 && (
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.totalAmountText}
        >
          Adjustment Difference:{" "}
          <span className={classes.amountValue}>
            {`${currency}${(getSubTotalPrice() - getOriginalSubTotalPrice()).toFixed(2)}`}
          </span>
        </Typography>
      )}
      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        Discount:{" "}
        <span className={classes.amountValue}>
          {discountVal && discountFlag && cartItems.length ? (
            <Chip
              size="small"
              icon={<LocalOfferOutlinedIcon style={{ fontSize: 13, color: "#16a34a" }} />}
              label={`${currency}${discountVal.toFixed(2)}`}
              onDelete={clearDiscount}
              style={{
                height: 24,
                fontSize: "0.75rem",
                fontWeight: 700,
                backgroundColor: "#dcfce7",
                color: "#15803d",
                borderRadius: 6,
                border: "1px solid #bbf7d0",
              }}
            />
          ) : (
            <Button
              size="small"
              variant="outlined"
              startIcon={<LocalOfferOutlinedIcon style={{ fontSize: 13 }} />}
              onClick={handleDisountBoxOpen}
              disabled={loading || !cartItems.length || (!isAdmin && !canApplyDiscount)}
              style={{
                height: 24,
                padding: "1px 8px",
                fontSize: "0.72rem",
                fontWeight: 600,
                textTransform: "none",
                borderRadius: 6,
                borderColor: "#cbd5e1",
                color:
                  loading || !cartItems.length || (!isAdmin && !canApplyDiscount)
                    ? "#94a3b8"
                    : "#0284c7",
                backgroundColor:
                  loading || !cartItems.length || (!isAdmin && !canApplyDiscount)
                    ? "#f1f5f9"
                    : "#f0f9ff",
                cursor:
                  loading || !cartItems.length || (!isAdmin && !canApplyDiscount)
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              + Discount
            </Button>
          )}
        </span>
      </Typography>

      <Modal
        open={openDiscountbox}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDisountBoxClose();
          }
        }}
      >
        <div className={classes.modal} style={{ borderRadius: 14, maxWidth: 360, padding: 24 }}>
          <Typography variant="h6" style={{ fontWeight: 700, fontSize: "1rem", marginBottom: 16, color: "#1e293b" }}>
            Apply Discount
          </Typography>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <TextField
              error={isError}
              helperText={isError ? "Incorrect entry." : null}
              type="number"
              label="Discount Value"
              variant="outlined"
              size="small"
              value={discountVal}
              onChange={(e) => {
                setDiscountVal(e.target.value);
              }}
              style={{ flex: 1 }}
            />
            <ButtonGroup
              disableElevation
              variant="contained"
              size="small"
              style={{ height: 40 }}
            >
              <Button
                onClick={handleDiscountTypeChange}
                style={{
                  backgroundColor: discountType === false ? "#ef7f1a" : "#f1f5f9",
                  color: discountType === false ? "#ffffff" : "#475569",
                  fontWeight: 600,
                }}
              >
                Flat
              </Button>
              <Button
                onClick={handleDiscountTypeChange}
                style={{
                  backgroundColor: discountType ? "#ef7f1a" : "#f1f5f9",
                  color: discountType ? "#ffffff" : "#475569",
                  fontWeight: 600,
                }}
              >
                %
              </Button>
            </ButtonGroup>
          </div>
          <div className={classes.modalButtons} style={{ marginTop: 20, display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={handleDisountBoxClose}
              style={{ textTransform: "none", fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              disabled={isError}
              onClick={() => {
                handleAddDiscount(getSubTotalPrice().toFixed(2));
              }}
              style={{
                backgroundColor: isError ? "#e2e8f0" : "#ef7f1a",
                color: isError ? "#94a3b8" : "#ffffff",
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      </Modal>

      <Typography
        variant="body1"
        color="initial"
        className={classes.totalAmountText}
      >
        {taxLabel}:{" "}
        <span className={classes.amountValue}>
          {`${currency}${calculateVat().toFixed(2)}`}
        </span>
      </Typography>

      {getRoundOff && getRoundOff() !== 0 && (
        <Typography
          variant="body1"
          color="initial"
          className={classes.totalAmountText}
        >
          Round off:{" "}
          <span className={classes.amountValue}>
            {`${getRoundOff() > 0 ? "+" : "-"}${currency}${Math.abs(getRoundOff()).toFixed(2)}`}
          </span>
        </Typography>
      )}

      <div className={classes.totalCard}>
        <span className={classes.totalLabel}>Total Amount:</span>
        <span className={classes.totalValue}>
          {`${currency}${formatFinalAmount(getTotalPrice())}`}
        </span>
      </div>
    </div>
  );
};

export default CartSummary;
